module.exports = "fonts/GilroyLight.woff";